export default "__VITE_ASSET__C$$p4WU5__"